import { useStoreState } from '~/store/hooks';
import formatDictionaryOptions from '~/utils/formatDictionaryOptions';
import { IDictionaryTypes } from '~/services/api/dictionaries/types';
import { IOption } from '~/types';

const useDictionaryOptions = (type: IDictionaryTypes): IOption[] => {
  const list = useStoreState(state => state.dictionaries.availableDictionaries[type]?.list);

  return formatDictionaryOptions(list || []);
};

export default useDictionaryOptions;
